import type { z } from 'zod';
import { exceptionalEventSchema } from '@/schemas/API/GET/employee/exceptional-event/response';

export const createExceptionalEventSchema = exceptionalEventSchema.omit({
  id: true,
  empId: true,
});

export type CreateExceptionalEvent = z.infer<
  typeof createExceptionalEventSchema
>;
